<template>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0">
        <div class="fixed-nav">
            <div class="nav-tabs-wrap mt-n20 mb-0" v-if="$route.name == 'allMatches'">
                <ul role="tablist" class="nav nav-tabs days-nav">
                    <li v-for="day in currentWeek" class="flex-grow-1 text-center" :key="day" role="tab">
                    <router-link :to="{ name: 'allMatches',params:{ date: day} }" :class="{ active: date == day }">
                        {{ day == getTodayDate() ? 'Today' : day | formatDate3 }}<br />{{ day | formatDate('MMM D') }}
                    </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="text-center mt-30" v-if="!is_data_ready">
            <template v-if="$store.getters.theme == 'dark'">
                <svg class="card-match" viewBox="0 0 593 162" preserveAspectRatio="xMidYMid meet"><rect clip-path="url(#8fieetwe4qq)" x="0" y="0" width="593" height="162" style="fill: url(&quot;#589vzlirq3r&quot;);"></rect><defs><clipPath id="8fieetwe4qq"><rect x="50" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><circle cx="24.7" cy="23.7" r="17.7"></circle><rect x="26.5" y="32.08" rx="0" ry="0" width="0" height="0"></rect><rect x="33.5" y="36.08" rx="0" ry="0" width="0" height="0"></rect><rect x="122" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="10.5" y="65.08" rx="0" ry="0" width="37.4" height="23"></rect><rect x="58" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="525" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="9" y="101.34" rx="4" ry="4" width="120.98" height="20.7"></rect><rect x="469" y="99.34" rx="4" ry="4" width="120.98" height="20.7"></rect><circle cx="293.64888583261313" cy="72.22888583261314" r="17.148885832613146"></circle><rect x="0" y="0" rx="4" ry="4" width="0" height="0"></rect><rect x="11" y="148.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="359" y="147.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="417.83" y="20.34" rx="4" ry="4" width="171.81" height="9.8"></rect></clipPath><linearGradient id="589vzlirq3r"><stop offset="0%" stop-color="#2b2f34" stop-opacity="1"><animate attributeName="offset" values="-3; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#777a7e" stop-opacity="1"><animate attributeName="offset" values="-2; 2" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#2b2f34" stop-opacity="1"><animate attributeName="offset" values="-1; 3" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg><br />
                <svg class="card-match" viewBox="0 0 593 162" preserveAspectRatio="xMidYMid meet"><rect clip-path="url(#8fieetwe4qq)" x="0" y="0" width="593" height="162" style="fill: url(&quot;#589vzlirq3r&quot;);"></rect><defs><clipPath id="8fieetwe4qq"><rect x="50" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><circle cx="24.7" cy="23.7" r="17.7"></circle><rect x="26.5" y="32.08" rx="0" ry="0" width="0" height="0"></rect><rect x="33.5" y="36.08" rx="0" ry="0" width="0" height="0"></rect><rect x="122" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="10.5" y="65.08" rx="0" ry="0" width="37.4" height="23"></rect><rect x="58" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="525" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="9" y="101.34" rx="4" ry="4" width="120.98" height="20.7"></rect><rect x="469" y="99.34" rx="4" ry="4" width="120.98" height="20.7"></rect><circle cx="293.64888583261313" cy="72.22888583261314" r="17.148885832613146"></circle><rect x="0" y="0" rx="4" ry="4" width="0" height="0"></rect><rect x="11" y="148.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="359" y="147.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="417.83" y="20.34" rx="4" ry="4" width="171.81" height="9.8"></rect></clipPath><linearGradient id="589vzlirq3r"><stop offset="0%" stop-color="#2b2f34" stop-opacity="1"><animate attributeName="offset" values="-3; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#777a7e" stop-opacity="1"><animate attributeName="offset" values="-2; 2" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#2b2f34" stop-opacity="1"><animate attributeName="offset" values="-1; 3" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg><br />
                <svg class="card-match" viewBox="0 0 593 162" preserveAspectRatio="xMidYMid meet"><rect clip-path="url(#8fieetwe4qq)" x="0" y="0" width="593" height="162" style="fill: url(&quot;#589vzlirq3r&quot;);"></rect><defs><clipPath id="8fieetwe4qq"><rect x="50" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><circle cx="24.7" cy="23.7" r="17.7"></circle><rect x="26.5" y="32.08" rx="0" ry="0" width="0" height="0"></rect><rect x="33.5" y="36.08" rx="0" ry="0" width="0" height="0"></rect><rect x="122" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="10.5" y="65.08" rx="0" ry="0" width="37.4" height="23"></rect><rect x="58" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="525" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="9" y="101.34" rx="4" ry="4" width="120.98" height="20.7"></rect><rect x="469" y="99.34" rx="4" ry="4" width="120.98" height="20.7"></rect><circle cx="293.64888583261313" cy="72.22888583261314" r="17.148885832613146"></circle><rect x="0" y="0" rx="4" ry="4" width="0" height="0"></rect><rect x="11" y="148.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="359" y="147.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="417.83" y="20.34" rx="4" ry="4" width="171.81" height="9.8"></rect></clipPath><linearGradient id="589vzlirq3r"><stop offset="0%" stop-color="#2b2f34" stop-opacity="1"><animate attributeName="offset" values="-3; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#777a7e" stop-opacity="1"><animate attributeName="offset" values="-2; 2" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#2b2f34" stop-opacity="1"><animate attributeName="offset" values="-1; 3" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg><br />
                <svg class="card-match" viewBox="0 0 593 162" preserveAspectRatio="xMidYMid meet"><rect clip-path="url(#8fieetwe4qq)" x="0" y="0" width="593" height="162" style="fill: url(&quot;#589vzlirq3r&quot;);"></rect><defs><clipPath id="8fieetwe4qq"><rect x="50" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><circle cx="24.7" cy="23.7" r="17.7"></circle><rect x="26.5" y="32.08" rx="0" ry="0" width="0" height="0"></rect><rect x="33.5" y="36.08" rx="0" ry="0" width="0" height="0"></rect><rect x="122" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="10.5" y="65.08" rx="0" ry="0" width="37.4" height="23"></rect><rect x="58" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="525" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="9" y="101.34" rx="4" ry="4" width="120.98" height="20.7"></rect><rect x="469" y="99.34" rx="4" ry="4" width="120.98" height="20.7"></rect><circle cx="293.64888583261313" cy="72.22888583261314" r="17.148885832613146"></circle><rect x="0" y="0" rx="4" ry="4" width="0" height="0"></rect><rect x="11" y="148.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="359" y="147.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="417.83" y="20.34" rx="4" ry="4" width="171.81" height="9.8"></rect></clipPath><linearGradient id="589vzlirq3r"><stop offset="0%" stop-color="#2b2f34" stop-opacity="1"><animate attributeName="offset" values="-3; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#777a7e" stop-opacity="1"><animate attributeName="offset" values="-2; 2" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#2b2f34" stop-opacity="1"><animate attributeName="offset" values="-1; 3" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg><br />
            </template>
            <template v-else>
                <svg class="card-match" viewBox="0 0 593 162" preserveAspectRatio="xMidYMid meet"><rect clip-path="url(#yw6hnoqne3h)" x="0" y="0" width="593" height="162" style="fill: url(&quot;#tzbkw99jhk&quot;);"></rect><defs><clipPath id="yw6hnoqne3h"><rect x="50" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><circle cx="24.7" cy="23.7" r="17.7"></circle><rect x="26.5" y="32.08" rx="0" ry="0" width="0" height="0"></rect><rect x="33.5" y="36.08" rx="0" ry="0" width="0" height="0"></rect><rect x="122" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="10.5" y="65.08" rx="0" ry="0" width="37.4" height="23"></rect><rect x="58" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="525" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="9" y="101.34" rx="4" ry="4" width="120.98" height="20.7"></rect><rect x="469" y="99.34" rx="4" ry="4" width="120.98" height="20.7"></rect><circle cx="293.64888583261313" cy="72.22888583261314" r="17.148885832613146"></circle><rect x="0" y="0" rx="4" ry="4" width="0" height="0"></rect><rect x="11" y="148.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="359" y="147.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="417.83" y="20.34" rx="4" ry="4" width="171.81" height="9.8"></rect></clipPath><linearGradient id="tzbkw99jhk"><stop offset="0%" stop-color="#f0f0f0" stop-opacity="1"><animate attributeName="offset" values="-3; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#d1cccc" stop-opacity="1"><animate attributeName="offset" values="-2; 2" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#f0f0f0" stop-opacity="1"><animate attributeName="offset" values="-1; 3" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg><br />
                <svg class="card-match" viewBox="0 0 593 162" preserveAspectRatio="xMidYMid meet"><rect clip-path="url(#yw6hnoqne3h)" x="0" y="0" width="593" height="162" style="fill: url(&quot;#tzbkw99jhk&quot;);"></rect><defs><clipPath id="yw6hnoqne3h"><rect x="50" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><circle cx="24.7" cy="23.7" r="17.7"></circle><rect x="26.5" y="32.08" rx="0" ry="0" width="0" height="0"></rect><rect x="33.5" y="36.08" rx="0" ry="0" width="0" height="0"></rect><rect x="122" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="10.5" y="65.08" rx="0" ry="0" width="37.4" height="23"></rect><rect x="58" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="525" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="9" y="101.34" rx="4" ry="4" width="120.98" height="20.7"></rect><rect x="469" y="99.34" rx="4" ry="4" width="120.98" height="20.7"></rect><circle cx="293.64888583261313" cy="72.22888583261314" r="17.148885832613146"></circle><rect x="0" y="0" rx="4" ry="4" width="0" height="0"></rect><rect x="11" y="148.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="359" y="147.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="417.83" y="20.34" rx="4" ry="4" width="171.81" height="9.8"></rect></clipPath><linearGradient id="tzbkw99jhk"><stop offset="0%" stop-color="#f0f0f0" stop-opacity="1"><animate attributeName="offset" values="-3; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#d1cccc" stop-opacity="1"><animate attributeName="offset" values="-2; 2" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#f0f0f0" stop-opacity="1"><animate attributeName="offset" values="-1; 3" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg><br />
                <svg class="card-match" viewBox="0 0 593 162" preserveAspectRatio="xMidYMid meet"><rect clip-path="url(#yw6hnoqne3h)" x="0" y="0" width="593" height="162" style="fill: url(&quot;#tzbkw99jhk&quot;);"></rect><defs><clipPath id="yw6hnoqne3h"><rect x="50" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><circle cx="24.7" cy="23.7" r="17.7"></circle><rect x="26.5" y="32.08" rx="0" ry="0" width="0" height="0"></rect><rect x="33.5" y="36.08" rx="0" ry="0" width="0" height="0"></rect><rect x="122" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="10.5" y="65.08" rx="0" ry="0" width="37.4" height="23"></rect><rect x="58" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="525" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="9" y="101.34" rx="4" ry="4" width="120.98" height="20.7"></rect><rect x="469" y="99.34" rx="4" ry="4" width="120.98" height="20.7"></rect><circle cx="293.64888583261313" cy="72.22888583261314" r="17.148885832613146"></circle><rect x="0" y="0" rx="4" ry="4" width="0" height="0"></rect><rect x="11" y="148.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="359" y="147.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="417.83" y="20.34" rx="4" ry="4" width="171.81" height="9.8"></rect></clipPath><linearGradient id="tzbkw99jhk"><stop offset="0%" stop-color="#f0f0f0" stop-opacity="1"><animate attributeName="offset" values="-3; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#d1cccc" stop-opacity="1"><animate attributeName="offset" values="-2; 2" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#f0f0f0" stop-opacity="1"><animate attributeName="offset" values="-1; 3" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg><br />
                <svg class="card-match" viewBox="0 0 593 162" preserveAspectRatio="xMidYMid meet"><rect clip-path="url(#yw6hnoqne3h)" x="0" y="0" width="593" height="162" style="fill: url(&quot;#tzbkw99jhk&quot;);"></rect><defs><clipPath id="yw6hnoqne3h"><rect x="50" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><circle cx="24.7" cy="23.7" r="17.7"></circle><rect x="26.5" y="32.08" rx="0" ry="0" width="0" height="0"></rect><rect x="33.5" y="36.08" rx="0" ry="0" width="0" height="0"></rect><rect x="122" y="17.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="10.5" y="65.08" rx="0" ry="0" width="37.4" height="23"></rect><rect x="58" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="525" y="70.34" rx="4" ry="4" width="64.35" height="11.01"></rect><rect x="9" y="101.34" rx="4" ry="4" width="120.98" height="20.7"></rect><rect x="469" y="99.34" rx="4" ry="4" width="120.98" height="20.7"></rect><circle cx="293.64888583261313" cy="72.22888583261314" r="17.148885832613146"></circle><rect x="0" y="0" rx="4" ry="4" width="0" height="0"></rect><rect x="11" y="148.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="359" y="147.34" rx="4" ry="4" width="231.07" height="6.42"></rect><rect x="417.83" y="20.34" rx="4" ry="4" width="171.81" height="9.8"></rect></clipPath><linearGradient id="tzbkw99jhk"><stop offset="0%" stop-color="#f0f0f0" stop-opacity="1"><animate attributeName="offset" values="-3; 1" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="50%" stop-color="#d1cccc" stop-opacity="1"><animate attributeName="offset" values="-2; 2" dur="1s" repeatCount="indefinite"></animate></stop><stop offset="100%" stop-color="#f0f0f0" stop-opacity="1"><animate attributeName="offset" values="-1; 3" dur="1s" repeatCount="indefinite"></animate></stop></linearGradient></defs></svg><br />
            </template>
        </div>
        <div class="text-center mt-30" v-else-if="groupedMatches.length == 0">
            <p v-if="$route.name == 'allMatches'">No match data found against ICC <span class="text-capitalize">{{ iccFilter.replace(/-/g,' ') }}</span>.</p>
            <p v-else-if="$route.name == 'liveMatches'">There are no live matches right now.</p>
            <p v-else-if="$route.name == 'myMatches'">
                There are no matches in favourites. To add a favourite match, tap on the star icon next to the match.
            </p>
        </div>
        <template v-else>
            <h1 v-if="$route.name == 'liveMatches'">Cricket Matches in Play</h1>
            <h1 v-else-if="$route.name == 'myMatches'">My Cricket Games</h1>
            <h1 v-else-if="$route.name == 'allMatches'">Live Cricket Score & Live Cricket Matches {{  geth1  }}</h1>
            <!-----------------------------Pinned Leagues ------------------------->
            <div class="league-matches-wrap" v-for="tournament in $store.getters.pinnedLeagues" :key="tournament.id"  v-if="groupedMatches[tournament.name]">

                <div class="league-head">
                    <div class="heading">
                        <router-link :to="{ name: 'tournamentDetail.Matches', params: { tournament: tournament.slug } }">
                            <div class="icon-flag">
                                <img width="26" height="26" class="lazyload" :src="tournament.country_flag.resizeImage(36,36)" :alt="tournament.country_name" />
                            </div>
                            <h3>{{ tournament.country_name }} | {{ tournament.name }} | {{ groupedMatches[tournament.name][0].matchtype }}</h3>
                        </router-link>
                    </div>
                    <div class="league-head-right">
                        <a
                            @click.prevent="
                            togglePinned(groupedMatches[tournament.name][0].tournament, groupedMatches[tournament.name][0].tournament.country)
                            "
                            class="pin-btn active"
                            >
                            <i class="ico-unpin"></i>
                        </a>
                        <router-link class="see-all" :to="{ name: 'tournamentDetail.Matches', params: { tournament: tournament.slug } }" aria-label="abc">
                                     <i class="ico-right-arrow"></i>
                        </router-link>
                    </div>
                </div>
                <match-card
                    v-for="match in Object.values(groupedMatches[tournament.name]).sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))"
                    :key="match.id"
                    :match="match"
                    ></match-card>
            </div>




 <!------------------------------Pinned ICC Leagues----------------------->
            <template v-for="type in $store.getters.pinnedIccTypes">
                <div class="league-matches-wrap" v-if="!iccFilter && getIccVariable(type).length" :key="type">
                    <div class="league-head">
                        <div class="heading">
                            <router-link :to="{ name: 'allMatches', params: { date: date, icc: `${type.slugify()}` } }">
                                <div class="icon-flag">
                                    <img width="26" height="26" loading="lazy" :src="($storageURL + 'country_flags/International.png').resizeImage(36,36)" alt="ICC" />
                                </div>
                                <h2>International | {{ type }} </h2>
                            </router-link>
                        </div>
                        <div class="league-head-right">
                            <span @click.prevent="$store.commit('removePinnedIccType', type)" class="pin-btn active">
                                <i class="ico-unpin"></i>
                            </span>
                            <router-link :to="{ name: 'allMatches', params: { date : date ,icc: `${type.slugify()}` } }" class="see-all" aria-label="ddv"
                                ><i class="ico-right-arrow"></i
                                ></router-link>
                        </div>
                    </div>
                    <match-card v-for="match in getIccVariable(type)" :key="match.id" :match="match"></match-card>
                </div>
                <div v-else>
                </div>
            </template>

            <!------------------------------Non-Pinned ICC Leagues--------------------------------->
            <template v-for="type in getUnpinnedICC">
                <div class="league-matches-wrap" v-if="!iccFilter && getIccVariable(type).length" :key="type">
                    <div class="league-head">
                        <div class="heading" v-if="type === 'T20 World Cup'">
                            <router-link :to="{ name: 'tournamentDetail.Matches', params: { tournament: t20WCup.length>0?t20WCup[0].tournament.slug:'' } }">
                                <div class="icon-flag">
                                    <img width="26" height="26" loading="lazy" :src="($storageURL + 'country_flags/International.png').resizeImage(36,36)" alt="ICC" />
                                </div>
                                <h2>International | {{ type }}</h2>
                            </router-link>
                        </div>
                        <div class="heading" v-else>
                            <router-link :to="{ name: 'allMatches', params: { date: date ,icc: `${type.slugify()}` } }">
                                <div class="icon-flag">
                                    <img width="26" height="26" loading="lazy" :src="($storageURL + 'country_flags/International.png').resizeImage(36,36)" alt="ICC" />
                                </div>
                                <h2>International | {{ type }}</h2>
                            </router-link>
                        </div>
                        <div class="league-head-right">
                            <span @click.prevent="$store.commit('addPinnedIccType', type)" class="pin-btn">
                                <i class="ico-unpin"></i>
                            </span>
                            <router-link :to="{ name: 'allMatches', params: { date : date ,icc: `${type.slugify()}` } }" class="see-all" aria-label="ICC"
                                ><i class="ico-right-arrow"></i
                                ></router-link>
                        </div>
                    </div>
                    <match-card v-for="match in getIccVariable(type)" :key="match.id" :match="match"></match-card>
                </div>
                <div v-else>
                </div>
            </template>

            <!-------------------------------------------Remaining Leagues---------------------------------------->

            <div class="league-matches-wrap" v-for="(matches, index) in otherMatches" :key="index">
                <div class="league-head">
                    <div class="heading">
                        <router-link :to="{ name: 'tournamentDetail.Matches', params: { tournament: matches[0].tournament.slug } }">
                            <div class="icon-flag">
                                <img width="26" height="26" loading="lazy" :src="matches[0].tournament.country.flag.resizeImage(36,36)" alt="ICC" />
                            </div>
                            <h2>{{ matches[0].tournament.country.name }} | {{ matches[0].tournament.name }} | {{ matches[0].matchtype }}</h2>
                        </router-link>
                    </div>
                    <div class="league-head-right">

                        <span
                            @click.prevent="
                            togglePinned(matches[0].tournament, matches[0].tournament.country)
                            "
                            class="pin-btn"
                            >
                            <i class="ico-unpin"></i>
                        </span>
                        <router-link class="see-all" :to="{ name: 'tournamentDetail.Matches', params: { tournament: matches[0].tournament.slug } }" alt="ICC" aria-label="ICC">
                                     <i class="ico-right-arrow"></i>
                        </router-link>
                    </div>
                </div>
                <template v-for="(match,i) in matches" >
                <match-card :key="match.id" :match="match"></match-card>
                <!-------------------------------------------Ads---------------------------------------->
                <div style="display:flex;justify-content: center;width: 100%; margin-bottom: 12px;" class="d-md-none" v-if="index == 0 && i == 0">

                    <div class="ft_async_tag" style="width: 300px;">
            
                        <iframe :src="'https://servedby.flashtalking.com/imp/1/162408;7132164;201;jsiframe;PlanetCricket;PlanetCricket300x250/?ft_custom=&imageType=gif&ftDestID=35488582&ft_width=300&ft_height=250&click=&ftOBA=1&ftExpTrack=&gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&cachebuster='+Date.now()" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" topmargin="0" leftmargin="0" allowtransparency="true" width="300" height="250">
            
                            <a href="https://servedby.flashtalking.com/click/1/162408;7132164;0;209;0/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&ft_width=300&ft_height=250&url=35488582" target="_blank">
                            
                            <img border="0" src="https://servedby.flashtalking.com/imp/1/162408;7132164;205;gif;PlanetCricket;PlanetCricket300x250/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}"></a>
                            
                            </iframe>
                    </div>

                    </div>
                <!-------------------------------------------Ads End---------------------------------------->
                </template>
            </div>



        </template>
         <div v-if="iccFilter !== '' && groupedMatches.length == 0">
          <div class="league-matches-wrap" v-for="(matches, index) in liveMatches" :key="index">

                <div class="league-head">
                    <div class="heading">
                        <router-link :to="{ name: 'tournamentDetail.Matches', params: { tournament: matches[0].tournament.slug } }">
                            <div class="icon-flag">
                                <img width="26" height="26" loading="lazy" :src="matches[0].tournament.country.flag.resizeImage(36,36)" alt="ICC" />
                            </div>
                            <h2>{{ matches[0].tournament.country.name }} | {{ matches[0].tournament.name }} | {{ matches[0].matchtype }}</h2>
                        </router-link>
                    </div>
                    <div class="league-head-right">

                        <span
                            @click.prevent="
                            togglePinned(matches[0].tournament, matches[0].tournament.country)
                            "
                            class="pin-btn"
                            >
                            <i class="ico-unpin"></i>
                        </span>
                        <router-link class="see-all" :to="{ name: 'tournamentDetail.Matches', params: { tournament: matches[0].tournament.slug } }" alt="ICC" aria-label="ICC">
                                     <i class="ico-right-arrow"></i>
                        </router-link>
                    </div>
                </div>
                <match-card v-for="match in matches" :key="match.id" :match="match"></match-card>
            </div>
         </div>
<!--      footer text-->
      <div class="note-text text-center py-10">
        <p v-if="$route.name == 'myMatches'">
          -
        </p>
        <p v-if="$route.name == 'liveMatches'">
            Planet Cricket Brings You the Fastest and the Most Competent Coverage of the Cricket Matches in Play from the World Over. Live Scores and Match Updates, Catch All the Live Action and Updates of Cricket Matches in Play.
        </p>
        <p v-if="$route.name == 'allMatches'">
            Welcome to Planet Cricket, Where You Can Get All the Live Cricket Score & Live Cricket Matches from Around the Globe 24/7. Never Miss Live Cricket Score & Live Cricket Matches with the Fastest Updates Only on Planet Cricket.
        </p>
      </div>
    </div>

</template>

<script>
    import MatchCard from './MatchCard'
    import moment from 'moment'

    export default {
        name: 'allMatches',

        components: {
            MatchCard
        },

        data() {
            return {
                groupedMatches: [],
                iccFilter: '',
                date: null,
                liveMatches:[]

            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.groupedMatches)
                return

            let matches = Object.values(this.groupedMatches).flat(1) || [];
            let events = [];
            matches.forEach((match) => {
                events.push(
                        {
                            "@type": "SportsEvent",
                            "name": match.team1.name + " VS " + match.team2.name,
                            "description": match.tournament.name + " - " + match.team1.name + " VS " + match.team2.name + " - " + match.matchno,
                            "url": process.env.BASE_URL + "match/" + match.slug + "/teams",
                            "eventStatus": "http://schema.org/EventScheduled",
                            "eventAttendanceMode": "http://schema.org/OfflineEventAttendanceMode",
                            "startDate": moment(match.gmt_datetime).format('YYYY-MM-DD HH:MM'),
                            "endDate": moment(match.gmt_datetime).format('YYYY-MM-DD'),
                            "image": "https://planetcricket.com/public/images/logo1280x720.png",
                            "organizer": {
                                "@type": "Organization",
                                "name": match.tournament.name,
                                "url": process.env.BASE_URL + "tournament/" + match.tournament.slug + "/matches",
                            },
                            "performer": {
                                "@type": "Thing",
                                "name": match.team1.name + " VS " + match.team2.name,
                            },
                            "competitor": [
                                {
                                    "@type": "SportsTeam",
                                    "name": match.team1.name,
                                    "image": match.team1.flag
                                },
                                {
                                    "@type": "SportsTeam",
                                    "name": match.team2.name,
                                    "image": match.team2.flag
                                }
                            ],
                            "location": {
                                "@type": "Place",
                                "name": match.stadium.name + ", " + match.stadium.city + ", " + match.stadium.country,
                                "address": {
                                    "@type": "PostalAddress",
                                    "name": match.stadium.name + ", " + match.stadium.city + ", " + match.stadium.country,
                                }
                            }
                        }
                )
            });
            return {
                "@context": "http://schema.org",
                "@graph": events
            };

        },

        computed: {
            currentWeek() {
                return [
                    moment().add(-3, 'days').format('YYYY-MM-DD'),
                    moment().add(-2, 'days').format('YYYY-MM-DD'),
                    moment().add(-1, 'days').format('YYYY-MM-DD'),
                    moment().add(0, 'days').format('YYYY-MM-DD'),
                    moment().add(1, 'days').format('YYYY-MM-DD'),
                    moment().add(2, 'days').format('YYYY-MM-DD'),
                    moment().add(3, 'days').format('YYYY-MM-DD')
                ]
            },
            geth1() {

                if(this.$route.params.date && moment(new Date()).format('MMM D') != moment(this.$route.params.date).format('MMM D'))
                {
                    return moment(this.$route.params.date).format('MMM D');
                }else{
                    return "Today";
                }

            },
            getUnpinnedICC() {
                return ['T20 World Cup','Test Match', 'ODI', 'T20I', 'Youth ODI', 'Youth T20', 'Youth Test', 'List A ODI', 'List A T20', 'List A TEST'].filter(icc => !this.$store.getters.pinnedIccTypes.includes(icc))
            },

            iccODI() {
                return Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['ODI'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))
            },

            iccT20() {
                let t20 = Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['T20I'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1));
                // console.log(t20,'icc t20');
                return t20;
            },

            iccTest() {
                return Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['5 Day Test', 'Test Match', 'Women Test'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))
            },
            youthODI() {
                return Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['Youth ODI'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))
            },

            youthT20() {
                return Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['Youth T20'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))
            },

            youthTest() {
                return Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['Youth Test'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))
            },
            listA_ODI() {
                return Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['List A ODI', 'List A ODI (W)'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))
            },

            listA_T20() {
                return Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['List A T20'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))
            },

            listA_Test() {
                return Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['List A Test'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))
            },
            t20WCup(){
              return Object.values(this.groupedMatches)
                        .flat(1)
                        .filter(match => ['T20 World Cup'].includes(match.matchtype))
                        .sort((a, b) => (a.gmt_datetime > b.gmt_datetime ? 1 : -1))
            },

            otherMatches() {
                let sorting = ['India', 'New Zealand', 'Australia', 'England', 'Pakistan', 'South Africa', 'Sri Lanka', 'West Indies', 'Bangladesh', 'Zimbabwe'];
                let sorting2 = ['India', 'New Zealand', 'Australia', 'England', 'Pakistan', 'South Africa', 'Sri Lanka', 'West Indies', 'Bangladesh', 'Zimbabwe'];
                let matches = Object.values(this.groupedMatches)    //list of matches in Tournament Group
                if (this.iccFilter == '') {         // lets remove ICC and PINNED Leagues
                    matches = matches
                            .filter(match => !['ODI', 'T20I', '5 Day Test','T20 World Cup', 'Test Match', 'Women Test', 'Youth ODI', 'Youth T20', 'Youth Test', 'List A ODI', 'List A ODI (W)', 'List A T20', 'List A Test'].includes(match[0].matchtype))   //icc category
                            .filter(match => !this.$store.getters.pinnedLeagues.map(t => t.id).includes(match[0].tournament.id))
                }
                let top10 = matches
                        .filter(item => sorting.includes(item[0].tournament.country.name))
                        .map(item => {
                            let n = sorting.indexOf(item[0].tournament.country.name)
                            return [n, item]
                        })
                        .sort().map(j => j[1])

                let others = matches
                        .filter(item => !sorting2.includes(item[0].tournament.country.name))
                        .sort((a, b) => a[0].tournament.country.name < b[0].tournament.country.name ? -1 : 1)
                let other = [...top10, ...others];
                return other;
            }
        },
        metaInfo() {



            if (this.$route.name == "liveMatches") {
                let title = "Live Cricket Match, Score, Scorecard, Results, Fixture";
                let description = "Catch all the live cricket action, get matches live scores, results, team scoreboards, and fixtures of cricket leagues and tournaments - PlanetCricket";
                return {
                    title: title,
                    meta: this.$getMetaTags(title, description),
                    link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
                }

            } else if (this.$route.name == "myMatches") {
                let title = "My Matches - Add your matches in Favourite";
                let description = "Get your daily fix of cricket matches, stay updated with all the upcoming matches of your favorite cricket team, league, and tournament - PlanetCricket";
                return {
                    title: title,
                    meta: this.$getMetaTags(title, description),
                    link: [
                       {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
                }
            } else {
                let day = '';
                 if(this.$route.params.date && moment(new Date()).format('MMM D') != moment(this.$route.params.date).format('MMM D'))
                {
                    day =  moment(this.$route.params.date).format('MMM D');
                }else{
                    day = "Today";
                }
                let title = "Live Cricket Score  | Live Cricket Matches "  + day + " - PlanetCricket.com";
                let description = "Get all the latest cricket news, live scores, results, match schedules, articles, player & team updates, and cricket videos - PlanetCricket";
                return {
                    title: title,
                    meta: this.$getMetaTags(title, description),
                    link: [
                        {rel: 'canonical', href: this.groupedMatches.length == 0 ? 'https://planetcricket.com' : 'https://planetcricket.com'+this.$route.path}],
                }
            }

        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                this.iccFilter = this.$route.params.icc || '';
                this.date = this.$route.params.date || this.getTodayDate();
                return this.getMatches()
            }
        },
        mounted() {
            this.iccFilter = this.$route.params.icc || '';
            this.date = this.$route.params.date || this.getTodayDate();
            this.getMatches()
        },

        watch: {
            $route(to, from) {
                if(isBrowser) {
                    this.iccFilter = to.params.icc || '';
                    this.date = to.params.date || this.getTodayDate();
                    this.getMatches()
                }
            }

        },

        methods: {
            getMatches() {
                let params = {date: this.date, icc_filter: this.iccFilter, ttl: 0}
                this.$root.$emit('date', this.date);
                if (this.$route.name == 'myMatches') {
                    params.favourites = this.$store.getters.favouriteMatches.length > 0 ? this.$store.getters.favouriteMatches : ['']
                    delete params.date;
                } else if (this.$route.name == 'liveMatches') {
                    params = {
                        live: true,
                    }
                }
                if (global.clickedElement)
                    this.is_data_ready = false;
                return this.$axios
                        .get(this.$MATCHES_API, {params})
                        .then(response => {
                            this.is_data_ready = true
                            this.groupedMatches = response.data.result.matches || []
                            //remove favorite matches if it is finished +1 day
                            // this.getLiveMatches();
                            if (this.$route.name == 'myMatches')
                                this.removeFavoriteFinishedMatches(response.data.result.matches);
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            getLiveMatches(){
              let params = {
                  date:this.getTodayDate()
                }
                return this.$axios
                        .get(this.$MATCHES_API, {params})
                        .then(response => {
                          this.liveMatches = Object.values(response.data.result.matches);
                            let sorting = ['India', 'New Zealand', 'Australia', 'England', 'Pakistan', 'South Africa', 'Sri Lanka', 'West Indies', 'Bangladesh', 'Zimbabwe']
                            let sorting2 = ['India', 'New Zealand', 'Australia', 'England', 'Pakistan', 'South Africa', 'Sri Lanka', 'West Indies', 'Bangladesh', 'Zimbabwe']
                            let matches = Object.values(this.liveMatches)    //list of matches in Tournament Group
                            if (this.iccFilter == '') {         // lets remove ICC and PINNED Leagues
                                matches = matches
                                        .filter(match => !['ODI', 'T20I', '5 Day Test', 'Test Match', 'Women Test', 'Youth ODI', 'Youth T20', 'Youth Test', 'List A ODI', 'List A ODI (W)', 'List A T20', 'List A Test'].includes(match[0].matchtype))   //icc category
                                        .filter(match => !this.$store.getters.pinnedLeagues.map(t => t.id).includes(match[0].tournament.id))
                            }
                            let top10 = matches
                                    .filter(item => sorting.includes(item[0].tournament.country.name))
                                    .map(item => {
                                        let n = sorting.indexOf(item[0].tournament.country.name)
                                        return [n, item]
                                    })
                                    .sort().map(j => j[1])

                            let others = matches
                                    .filter(item => !sorting2.includes(item[0].tournament.country.name))
                                    .sort((a, b) => a[0].tournament.country.name < b[0].tournament.country.name ? -1 : 1)
                            this.liveMatches = [...top10, ...others];
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            getTodayDate() {
                return moment().add(0, 'days').format('YYYY-MM-DD')
            },

            togglePinned(tournament, country) {
                this.$store.commit(this.$store.getters.isLeaguePinned(tournament) ? 'removePinnedLeague' : 'addPinnedLeague', {
                    ...tournament,
                    ...{country_name: country.name, country_flag: country.flag}
                })
            },

            getIccVariable(type) {
            //   console.log(type,'type');
            //   console.log(this.t20WCup,'t20WCup');
                switch (type) {
                  case 'T20 World Cup':
                        return this.t20WCup
                    case 'ODI':
                        return this.iccODI
                    case 'T20I':
                        return this.iccT20
                    case 'Test Match':
                        return this.iccTest
                    case 'Youth ODI':
                        return this.youthODI
                    case 'Youth T20':
                        return this.youthT20
                    case 'Youth Test':
                        return this.youthTest
                    case 'List A ODI':
                        return this.listA_ODI
                    case 'List A T20':
                        return this.listA_T20
                    case 'List A TEST':
                        return this.listA_Test
                }
            },
            removeFavoriteFinishedMatches(matches) {
                matches = Object.values(matches).flat(1) || [];
                var favMatches = this.$store.getters.favouriteMatches;
                favMatches.forEach((matchSlug) => {
                    let match = matches.getObjectById(matchSlug, 'slug');
                    if (match && match.status == 'Finished' && moment().diff(match.gmt_datetime, 'days') >= 1) {
                        setTimeout(() => {
                            this.$store.commit('removeFavouriteMatch', matchSlug)
                        }, 100)
                    }
                });
            },
        }
    }
</script>
